import React, {useEffect, useState} from "react";
import reviewService, {deleteReview} from '../services/ReviewService';
import {Link} from "react-router-dom";
import DetailsList from "../Details/DetailsList";

// List of reviews.
const UserReviewList = ({userId}) => {

    // Fetch all the reviews from the database.
    const [reviewList, setReview] = useState([]);
    useEffect(() =>
                  reviewService.findAllUserReviews(userId)
                      .then(review => setReview(review)));

    // Delete the review
    const[reviews, setReviews] = useState([]);
    const deleteReview = (review) => {
        reviewService.deleteReview(review._id)
            .then(() => setReviews(
                reviews.filter(r => r !== review)
            ));
    }

    // If the list is not empty
    if (reviewList !== []) {
        // return the reviews as a list.
        return (
            <ul className="list-group">
                {
                    reviewList.map(review => {
                        return (
                            <div className="wd-row m-3 p-3">
                                <div className="wd-col-twentyPercent col-sm-2 col-md-2 col-lg-2 col-xl-1 col-xxl-1">
                                    <img src="https://i.picsum.photos/id/365/5616/3744.jpg?hmac=m9Chefr19BelgN9G4ErJVFBbdvNmA_xlbd0CjATLwhM"
                                         className="img-fluid wd-main-image" alt = "profilePic"/>
                                </div>
                                <div className="wd-col-eightyPercent col-10">
                                    <div className="wd-author">
                                        <Link to={`/details/${review.restaurantId}`}>
                                            <p id="author-name"><b>{review.restaurantName}</b></p>
                                        </Link>
                                        <br/>
                                        {
                                            // userId === review.userId &&
                                            <button type="button" className="btn btn-info" onClick={() => deleteReview(review)} style={{float:"right"}}>Delete</button>
                                            // <i className="fas fa-times" onClick={() => deleteReview(review)} style={{float:"right"}}></i>
                                        }
                                    </div><br/>
                                    <div className="wd-content">
                                        <p> {review.desc} </p>
                                    </div>
                                </div>
                            </div>

                            // <div className="wd-row mt-3">
                            //     <div className="wd-col-twentyPercent col-1">
                            //         <img src="https://i.picsum.photos/id/365/5616/3744.jpg?hmac=m9Chefr19BelgN9G4ErJVFBbdvNmA_xlbd0CjATLwhM"
                            //              className="img-fluid wd-main-image" alt = "profilePic"/>
                            //     </div>
                            //     <div className="wd-col-eightyPercent col-11">
                            //         <div className="wd-author">
                            //             <Link to={`/userProfile/${review.userId}`}>
                            //                 <p id="author-name"><b>{review.name}</b></p>
                            //             </Link>
                            //             <i className="fas fa-times"  style={{float:"right"}}></i>
                            //         </div><br/>
                            //         <div className="wd-content">
                            //             <p> {review.desc} </p>
                            //         </div>
                            //     </div>
                            // </div>
                        )
                    })
                }
            </ul>
        )
    }
}
export default UserReviewList;